import gql from 'graphql-tag';

export const PaginationFrag = gql`
  fragment PaginationFields on Pagination {
    pageNumber
    itemsPerPage
    totalItems
  }
`;
